import React from 'react'

const HidePasswordShow = (props) => {
    return <svg {...props} width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 3.75C5.83334 3.75 2.27501 6.34167 0.833344 10C2.27501 13.6583 5.83334 16.25 10 16.25C14.1667 16.25 17.725 13.6583 19.1667 10C17.725 6.34167 14.1667 3.75 10 3.75ZM10 14.1667C7.70001 14.1667 5.83334 12.3 5.83334 10C5.83334 7.7 7.70001 5.83333 10 5.83333C12.3 5.83333 14.1667 7.7 14.1667 10C14.1667 12.3 12.3 14.1667 10 14.1667ZM10 7.5C8.61668 7.5 7.50001 8.61667 7.50001 10C7.50001 11.3833 8.61668 12.5 10 12.5C11.3833 12.5 12.5 11.3833 12.5 10C12.5 8.61667 11.3833 7.5 10 7.5Z" fill="#7d7c7c" />
  </svg>
}

export default HidePasswordShow
